<template>
    <b-modal centered scrollable :visible="showModal" :id="id" :title="title" @hide="$emit('closed')">
        <b-container fluid>
            <b-form-row v-for="option in options" :key="option.id">
                <component class="option-component" :is="getOptionComponent(option)" :variable="option"/>
            </b-form-row>
        </b-container>
        <template #modal-footer>
            <b-button variant="success" @click="validate" class="ml-auto" size="sm" :disabled="loading">
                {{ $t("payment_method.buttons.continue") }}
            </b-button>
        </template>
    </b-modal>
</template>

<script>

import Discord from "./Options/Discord";
import Dropdown from "./Options/Dropdown";
import Input from "./Options/Input";

export default {
    name: "Options.vue",
    props: {
        showModal: {
            type: Boolean,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        package: {
            type: Number,
            required: true
        },
        options: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            loading: false
        }
    },
    computed: {
        values() {
            return this.options.reduce(function (accum, option) {
                if (option.name === 'discord_id') {
                    accum['discord_signature'] = option.discordSignature ? option.discordSignature : ''
                }

                accum[option.name] = option.value ? String(option.value) : '';
                return accum;
            }, {});
        }
    },
    methods: {
        getOptionComponent(option) {
            switch (option.type) {
                case 'discord_id':
                    return Discord;
                case 'dropdown':
                    return Dropdown;
                default:
                    return Input
            }
        },
        validate() {
            this.loading = true;

            let args = {'package': this.package, 'options': this.values};

            this.$store.dispatch('validatePackageOptions', args)
                .then(() => this.$emit('validated', this.values))
                .catch((error) => {
                    this.$swal({
                        type: 'error', text: error.response.data.detail
                            ? error.response.data.detail
                            : 'Unable to process package options.'
                    });
                })
                .finally(() => this.loading = false)
        }
    },
}
</script>

<style lang="scss" scoped>
.option-component {
    width: 100% !important;
}

.modal-body {
    .form-row:last-of-type .form-group {
        margin-bottom: 0;
    }
}
</style>
